import React, { FC } from 'react';

interface TimerSettingsProps {
  timerDuration: number;
  onTimerDurationChange: (duration: number) => void;
  isWriting: boolean;
}

const TimerSettings: FC<TimerSettingsProps> = ({
  timerDuration,
  onTimerDurationChange,
  isWriting,
}) => {
  const timerOptions = [30, 60, 120, 300, 600]; // in seconds: 30s, 1min, 2min, 5min, 10min
  
  // Calculate pause threshold (5% of timer duration)
  const pauseThreshold = Math.max(1, Math.round(timerDuration * 0.05));

  return (
    <div className="mb-6 p-4 bg-gray-50 rounded-lg shadow">
      <div className="grid grid-cols-1 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Timer Duration
          </label>
          <select
            value={timerDuration}
            onChange={(e) => onTimerDurationChange(Number(e.target.value))}
            disabled={isWriting}
            className="block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 disabled:opacity-50"
          >
            {timerOptions.map((option) => (
              <option key={option} value={option}>
                {option === 60 ? '1 min' : 
                 option === 120 ? '2 min' : 
                 option === 300 ? '5 min' : 
                 option === 600 ? '10 min' : 
                 `${option} sec`}
              </option>
            ))}
          </select>
          <p className="mt-2 text-sm text-gray-500 italic">
            Your text will be deleted if you pause for more than {pauseThreshold} seconds (5% of your selected time).
          </p>
        </div>
      </div>
    </div>
  );
};

export default TimerSettings; 